import styled from 'styled-components';
import {
  BackDrop,
  Flex,
  LoadingSpinner,
  SectionIconButton,
  SubHeaderContainerProps,
  useAsyncFunctionProgress,
  useDownloadFile,
} from '@equifinance/shared';
import { useState } from 'react';
import { AuditRecord } from '../../../../contexts/audit';
import { DownloadIcon, DownloadLink, HiddedA } from '../../../Products/ProductComponents';
import useAuditApi from '../../../../api/useAuditApi';
import { useAccountContext } from '../../../../contexts';

const TruncateText = styled.p`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const ClampedCell = styled.div`
  display: -webkit-box;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: break-space;
`;

const SubHeader = styled(Flex)`${({ theme }) => `
  gap: ${theme.padding[3]};
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.padding[5]};
`}`;

const DownloadButton = styled(Flex)`
  align-items: center;
`;

const LoadingBackDrop = styled(BackDrop)`
  background-color: rgba(46, 46, 46, 0.6);
`;

export const AuditHistoryExpandableCell = styled.div`${({ theme }) => `
  ${SectionIconButton} {
    color: ${theme.colours.primary[1]};
    :hover:not([disabled]) {
      transform: none;
    }
  }
`}`;

export function TableSubHeader({ searchComponent }: SubHeaderContainerProps) {
  const [loading, setLoading] = useState(false);
  const { id } = useAccountContext();
  const { getAuditHistoryDocument } = useAuditApi();
  const {
    downloadFile, downloadFileRef,
  } = useDownloadFile();
  const onDownloadAuditHistory = async () => {
    setLoading(true);
    const { fileName, documentData } = await getAuditHistoryDocument(id).finally(() => setLoading(false));

    downloadFile(fileName, documentData);
  };

  const { inProgress, execute: executeDownloadAuditHistory } = useAsyncFunctionProgress(onDownloadAuditHistory);

  return (
    <SubHeader>
      {searchComponent}
      <DownloadButton>
        <HiddedA ref={downloadFileRef} />
        <DownloadIcon disabled={inProgress} className="mi-download" />
        <DownloadLink
          disabled={inProgress}
          onClick={() => {
            if (inProgress) return;
            executeDownloadAuditHistory();
          }}
          aria-hidden="true"
        >
          Download audit history
        </DownloadLink>
      </DownloadButton>
      {loading && (
        <LoadingBackDrop>
          <LoadingSpinner />
        </LoadingBackDrop>
      )}
    </SubHeader>
  );
}

export function AuditHistoryCell(value: string) {
  return (
    <ClampedCell>
      {value}
    </ClampedCell>
  );
}

export function PerformedByCell({ actionByCompanyName, actionByEmailAddress }: AuditRecord) {
  return (
    <div>
      <TruncateText>{actionByCompanyName}</TruncateText>
      <TruncateText>{actionByEmailAddress}</TruncateText>
    </div>
  );
}
